import * as React from 'react';
import OAuth, { ConfigOptions, ConfigOptionsAPI, OAuthClientStatus } from '../../../api';
import { Button, Checkbox, Dropdown, Form, Grid, Icon, Input, Label, Modal, Popup } from 'semantic-ui-react';
import { AxiosResponse } from 'axios';
import axios from 'axios';
import Toast from '../../../sys/toast';

class State {
    adminRoleMapping: any;
    userRoleMapping: any;
    isRoleMappingSet: boolean;
    testButtonModal: boolean;
    testUsername: string;
    testPassword: string;
    testMessage: string;
    testSuccess: boolean;
    tmpPassword: string;
    tmpCertPass: string;
    isPasswordSet: boolean;
    isCertPassSet: boolean;
    filename: any;
    importButtonModal: boolean;
}

interface Props {

}

// tslint:disable-next-line:interface-name
interface LDAPConfig {
    hosts: string;
    port: number;
    encryptionType: string;
    baseDN: string;
    enableLdap: boolean;
    anonymousQuery: boolean;
    bindDN: string;
    password: string;
    loginAttribute: string;
    groupMembershipAttribute: string;
    sessionTimeout: number;
    roleMapping: string;
    certExcept: boolean;
    certPassEna: boolean;
    certPass: string;
}

export default class LDAPConfigurationPanel extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            adminRoleMapping: '',
            userRoleMapping: '',
            isRoleMappingSet: false,
            testButtonModal: false,
            testUsername: '',
            testPassword: '',
            testMessage: '',
            testSuccess: false,
            tmpPassword: '',
            tmpCertPass: '',
            isPasswordSet: false,
            isCertPassSet: false,
            filename: null,
            importButtonModal: false
        });
        this.handleTestModalClose = this.handleTestModalClose.bind(this);
        this.ldapTestModalSubmit = this.ldapTestModalSubmit.bind(this);
        this.handleImportModalClose = this.handleImportModalClose.bind(this);
    }

    replaceSemicolon(data: any) {
        // convert string to array and remove whitespace
        let dataToArray = data.split(';').map((item: { trim: () => void; }) => item.trim());
        // convert array to string replacing semicolon with new line
        return dataToArray.join('\n');
    }

    splitRoleMappingString(roleMappingString: string) {
        if (roleMappingString) {
            let rmArray = roleMappingString.split('\n');
            let admin = rmArray[0];

            admin = this.replaceSemicolon(admin);
            this.setState({
                adminRoleMapping: admin,
                userRoleMapping: rmArray[1],
                isRoleMappingSet: true
            });
        }
    }

    setPassword(password: string) {
        let pwd = '';

        if (password) {
            if (password === 'password') {
                pwd = '';
            } else if (password === 'PASSWORD') {
                pwd = 'PASSWORD';
            } else if (password !== '') {
                pwd = 'PASSWORD';
            }

            this.setState({
              tmpPassword: pwd,
              isPasswordSet: true
            });
        }
    }

    updatePassword() {
        if (this.state.tmpPassword === '') {
            return 'password';
        } else if (this.state.tmpPassword === 'PASSWORD') {
            return 'PASSWORD';
        } else {
            this.setState({
              isPasswordSet: false
            });
            return this.state.tmpPassword;
        }
    }

    setCertPassword(password: string) {
        let pwd = '';

        if (password) {
            if (password === 'password') {
                pwd = '';
            } else if (password === 'PASSWORD') {
                pwd = 'PASSWORD';
            } else if (password !== '') {
                pwd = 'PASSWORD';
            }

            this.setState({
              tmpCertPass: pwd,
              isCertPassSet: true
            });
        }
    }

    updateCertPassword() {
        if (this.state.tmpCertPass === '') {
            return 'password';
        } else if (this.state.tmpCertPass === 'PASSWORD') {
            return 'PASSWORD';
        } else {
            this.setState({
              isCertPassSet: false
            });
            return this.state.tmpCertPass;
        }
    }

    replaceNewLine(data: any) {
        // convert string to array and remove whitespace
        let dataToArray = data.split('\n').map((item: { trim: () => void; }) => item.trim());
        // convert array to string replacing new line with semicolon
        return dataToArray.join(';');
    }

    combineRoleMapping(adminRoleMappingString: any, userRoleMappingString: any) {
        if (adminRoleMappingString.endsWith('\n')) {
            adminRoleMappingString = adminRoleMappingString.substring(0, adminRoleMappingString.length - 1);
            this.setState({adminRoleMapping: adminRoleMappingString});
        }
        adminRoleMappingString = this.replaceNewLine(adminRoleMappingString);
        return adminRoleMappingString + '\n' + userRoleMappingString;
    }

    ldapTestModalSubmit() {
        const url = 'http://default/api/ldap/authuser';

        let testUsername = new Buffer(this.state.testUsername).toString('base64');
        let testPassword = new Buffer(this.state.testPassword).toString('base64');
        let data = {
            'name': testUsername,
            'pw': testPassword
        };

        axios.post(url, data)
            .then( (response: AxiosResponse) => {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    this.setState({testMessage: 'LDAP user authorization successful.', testSuccess: true});
                } else {
                    if (response.data.errDetail !== undefined) {
                        this.setState({testMessage: 'LDAP user authorization failed: ' + response.data.errDetail, testSuccess: false});
                    } else {
                        this.setState({testMessage: 'LDAP user authorization failed.', testSuccess: false});
                    }
                }
            }).catch( (error: AxiosResponse) => {
            // tslint:disable-next-line:no-console
            console.log('LDAP user authorization error: ', error);
            this.setState({testMessage: 'LDAP user authorization error: ' + error, testSuccess: false});
        });
    }

    handleTestModalClose() {
        this.setState({
            testButtonModal: false,
            testMessage: '',
            testSuccess: false
        });
    }

    handleImportModalClose() {
        this.setState({
          importButtonModal: false
        });
    }

    onUploadCertificate(e: any) {
        e.preventDefault();

        const uploadUrl = 'http://default/api/filedownload';
        let formData = new FormData();
        formData.append('file_type', '8'); // encryption certificate
        formData.append('file_data', this.state.filename);

        axios.post(uploadUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-meta-caption': 'Uploading encryption certificate ...'
            }
        }).then( (response: AxiosResponse) => {
            if (response.data !== undefined && response.data.code === 'SUCCESS') {
                Toast.info('Encryption certificate imported successfully.');
            } else {
                Toast.error('Import of encryption certificate failed.');
            }
        }).catch( (error: AxiosResponse) => {
            // tslint:disable-next-line:no-console
            console.log('encryption certificate import error: ', error);
            Toast.error('Import of encryption certificate failed. See console for details.');
        });
        // close modal
        this.setState({
          importButtonModal: false
        });
    }

    render() {
        const encryptionOptions = [{ value: 'None', text: 'None' }, { value: 'SSL', text: 'SSL' },
            { value: 'TLS', text: 'TLS' }];

        const inlineStyle = {
            modal: {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        /* Config Options API

            Use the ConfigOptionsAPI<> component to take care of all the gritty API data fetch and updates. We pass in
            our Options as a <generic parameter type>. Although it can work without the ProbeConfig type (using any),
            by specifying it our intellisense will work and type checking is performed.

            The ConfigOptionsAPI component renders a html FORM,

            Properties:
               module - specify the Options API module name that the options are contained (one of sysmgmt, abr, fm, port)
               defaults - specify default for options (if we dont, we will get a React controlled/uncontrolled warning in console)
               spinner - enable a spinner during initial loading of configuration (default is true but you probably wont see it fast enough)
        */

        return (
            <ConfigOptionsAPI<LDAPConfig>
                module="ldap"
                defaults={{
                    hosts: '',
                    port: 0,
                    encryptionType: '',
                    baseDN: '',
                    enableLdap: false,
                    anonymousQuery: false,
                    bindDN: '',
                    password: '',
                    loginAttribute: '',
                    groupMembershipAttribute: '',
                    sessionTimeout: 0,
                    roleMapping: '',
                    certExcept: false,
                    certPassEna: false,
                    certPass: ''
                }}
            >
                {(config: ConfigOptions<LDAPConfig>) => {
                    // want to see what options come back? enable this console.log
                    // console.log("config ", config);

                    /* here we render our config form. You should add at least one Apply button and tie a number of
                       HTML input components to the 'config' object. The config object supports these properties:

                       Get an option:
                       config.options.<option-name>

                       Update an option:
                       config.update.<option-name>(new_value)

                       Wire input onChange event to update an option:
                       <Input ... onChange={config.update.onChange.<option-name}

                     */

                    // tslint:disable-next-line:no-unused-expression
                    { !this.state.isRoleMappingSet && this.splitRoleMappingString(config.options.roleMapping); }
                    // tslint:disable-next-line:no-unused-expression
                    { !this.state.isPasswordSet && this.setPassword(config.options.password); }
                    // tslint:disable-next-line:no-unused-expression
                    { !this.state.isCertPassSet && this.setCertPassword(config.options.certPass); }

                    return (
                        <OAuth.Context>{(oauth: OAuthClientStatus) => (
                        <React.Fragment>
                            <div className="assetAliasFilters">
                                <Label className="system-config-pageHeader">
                                    LDAP Configuration
                                </Label>
                                <Button
                                    floated="right"
                                    className="filterPanel-right-primary-btn"
                                    content="Apply"
                                    title="Apply LDAP Config"
                                    onClick={() => {
                                        config.update.roleMapping(this.combineRoleMapping(this.state.adminRoleMapping, this.state.userRoleMapping));
                                        let newPassword = this.updatePassword();
                                        if (newPassword !== config.options.password) config.update.password(this.state.tmpPassword);
                                        let newCertPassword = this.updateCertPassword();
                                        if (newCertPassword !== config.options.certPass) config.update.certPass(this.state.tmpCertPass);
                                    }}
                                />
                                <Button
                                    floated="right"
                                    className="filterPanel-secondary-btn"
                                    icon="flask"
                                    content="Test"
                                    title="Test LDAP Config"
                                    onClick={() => {
                                        this.setState({testButtonModal: true});
                                    }}
                                />
                            </div>
                            <Checkbox
                                className="config-checkbox more-paddingLeft left-align-label-smallFont"
                                label="Enable LDAP"
                                checked={config.options.enableLdap}
                                onChange={config.onChange.enableLdap}
                            />
                            <fieldset className="fieldset-security ldapFieldSet">
                                <legend>Config Settings</legend>
                                <Form>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200"/>
                                        <Popup
                                            content="Separate multiple hosts with a ','"
                                            trigger={<Icon name="question circle"/>}
                                            // offset="0, 400px"
                                            inverted
                                            position="right center"
                                            wide
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200">
                                            Hosts:
                                        </Label>
                                        <Input
                                            className="input-width-550"
                                            placeholder="Separate multiple hosts with a ','"
                                            value={config.options.hosts}
                                            onChange={config.onChange.hosts}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200">
                                            Port:
                                        </Label>
                                        <Input
                                            className="input-width-250"
                                            type="number"
                                            min="0"
                                            max="65535"
                                            value={config.options.port}
                                            onChange={config.onChange.port}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200">
                                            Encryption Method:
                                        </Label>
                                        <Dropdown
                                            className="input-width-250 securityDropdown templateDropDown1"
                                            search
                                            selection
                                            options={encryptionOptions}
                                            value={config.options.encryptionType}
                                            onChange={config.onChange.encryptionType}
                                        />
                                        {config.options.encryptionType !== 'None' ?
                                        <React.Fragment>
                                            <Checkbox
                                                className="config-checkbox left-align-label-smallFont more-padding"
                                                label="Add Certificate Exception OR"
                                                checked={config.options.certExcept}
                                                onChange={config.onChange.certExcept}
                                            />
                                            <Button
                                                className="filterPanel-right-primary-btn"
                                                disabled={config.options.certExcept}
                                                content="Import Root CA Certificate"
                                                title="Import Certificate"
                                                onClick={() => {
                                                    this.setState({importButtonModal: true});
                                                }}
                                            />
                                        </React.Fragment> : '' }
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200">
                                            Base DN:
                                        </Label>
                                        <Input
                                            className="input-width-550"
                                            placeholder="Provide a DN where users are located (dc=t-online,dc=telestream,dc=net)"
                                            maxLength="127"
                                            value={config.options.baseDN}
                                            onChange={config.onChange.baseDN}
                                        />
                                    </Form.Group>
                                </Form>
                            </fieldset>
                            <fieldset className="fieldset-security ldapFieldSet">
                                <legend>Query User Information</legend>
                                <Form>
                                    <Form.Group grouped>
                                        <Checkbox
                                            className="config-checkbox left-align-label-smallFont more-paddingTop"
                                            label="Query Anonymously (if supported)"
                                            checked={config.options.anonymousQuery}
                                            onChange={config.onChange.anonymousQuery}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200">
                                            Bind DN:
                                        </Label>
                                        <Input
                                            className="input-width-550"
                                            // placeholder=""
                                            maxLength="127"
                                            value={config.options.bindDN}
                                            onChange={config.onChange.bindDN}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200">
                                            Password:
                                        </Label>
                                        <Input
                                            className="input-width-550"
                                            type="password"
                                            // placeholder="********"
                                            // Note: password is returned as string "PASSWORD" or "password": uppercase means set and lowercase means NOT set.
                                            value={this.state.tmpPassword}
                                            onChange={(event, data) => {
                                                this.setState({tmpPassword: data.value});
                                            }}
                                        />
                                    </Form.Group>
                                </Form>
                            </fieldset>
                            <fieldset className="fieldset-security ldapFieldSet">
                                <legend>Other Information</legend>
                                <Form>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200">
                                            Login Attribute:
                                        </Label>
                                        <Input
                                            className="input-width-550"
                                            placeholder="Default: uid"
                                            value={config.options.loginAttribute}
                                            onChange={config.onChange.loginAttribute}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200">
                                            Group Member Attribute:
                                        </Label>
                                        <Input
                                            className="input-width-550"
                                            placeholder="Default: memberOf"
                                            value={config.options.groupMembershipAttribute}
                                            onChange={config.onChange.groupMembershipAttribute}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200">
                                            Session Timeout (min):
                                        </Label>
                                        <Input
                                            className="input-width-250"
                                            type="number"
                                            min="0"
                                            max="25"
                                            value={config.options.sessionTimeout}
                                            onChange={config.onChange.sessionTimeout}
                                        />
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-200">
                                            User Role
                                        </Label>
                                        <Popup
                                            content="Multiple DNs for a single role are added with multiple lines separated by a line break (return or enter key)."
                                            trigger={<Icon name="question circle"/>}
                                            // offset="0, 400px"
                                            inverted
                                            position="right center"
                                            wide
                                        />
                                    </Form.Group>
                                    {/*<Form.Group grouped>*/}
                                    {/*    <div style={{display: 'flex'}}>*/}
                                    {/*        <Label className="right-align-label-200">*/}
                                    {/*            User:*/}
                                    {/*        </Label>*/}
                                    {/*        <Form.TextArea*/}
                                    {/*            className="textArea-width-750"*/}
                                    {/*            placeholder="Add DNs to be assigned the user role of 'User'"*/}
                                    {/*            value={this.state.userRoleMapping}*/}
                                    {/*            onChange={(event, data) => {this.setState({userRoleMapping: data.value}); }}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</Form.Group>*/}
                                    <Form.Group grouped>
                                        <div style={{display: 'flex'}}>
                                            <Label className="right-align-label-200">
                                                Admin:
                                            </Label>
                                            <Form.TextArea
                                                className="textArea-width-750"
                                                placeholder="Add DNs to be assigned the user role of 'Admin'"
                                                value={this.state.adminRoleMapping}
                                                onChange={(event, data) => {
                                                    this.setState({adminRoleMapping: data.value});
                                                }}
                                            />
                                        </div>
                                        <Label className="right-align-label-width190"/>
                                        <Label className="left-align-label-800">
                                            *Users that are not members of an 'Admin' group are assigned 'User' role privileges.
                                        </Label>
                                    </Form.Group>
                                </Form>
                            </fieldset>
                            <Modal
                                open={this.state.testButtonModal}
                                onClose={this.handleTestModalClose}
                                size="small"
                                style={inlineStyle.modal}
                            >
                                <Modal.Header>Test LDAP Configuration</Modal.Header>
                                <Modal.Content>
                                    <Form>
                                        <Grid columns={2} divided="vertically" padded="horizontally">
                                            <Grid.Row>
                                                <Grid.Column width={9}>
                                                    <div className="ldapTestModal">
                                                        <Label className="right-align-label-90">
                                                            Username:
                                                        </Label>
                                                        <Input
                                                            className="input-width-200"
                                                            value={this.state.testUsername}
                                                            onChange={(event: any, data: any) => this.setState({testUsername: data.value})}
                                                        />
                                                    </div>
                                                    <div className="ldapTestModal">
                                                        <Label className="right-align-label-90">
                                                            Password:
                                                        </Label>
                                                        <Input
                                                            className="input-width-200"
                                                            type="password"
                                                            value={this.state.testPassword}
                                                            onChange={(event: any, data: any) => this.setState({testPassword: data.value})}
                                                        />
                                                    </div>
                                                </Grid.Column>
                                                <Grid.Column width={7}>
                                                    <div className="ldapTestModal">
                                                        {this.state.testSuccess ?
                                                            <p style={{color: 'blue', fontSize: '12px'}}>
                                                                {this.state.testMessage}
                                                            </p>
                                                            :
                                                            <p style={{color: 'red', fontSize: '12px'}}>
                                                                {this.state.testMessage}
                                                            </p>
                                                        }
                                                    </div>
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                                <br/><br/><br/>
                                                <br/><br/><br/>
                                            </Grid.Row>
                                        </Grid>
                                    </Form>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button
                                        floated="left"
                                        className="filterPanel-primary-btn modal-button-padding"
                                        onClick={() => this.ldapTestModalSubmit()}
                                    >
                                        Test
                                    </Button>
                                    <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleTestModalClose}>
                                        Close
                                    </Button>
                                </Modal.Actions>
                            </Modal>
                            <Modal
                                open={this.state.importButtonModal}
                                onClose={this.handleImportModalClose}
                                size="small"
                                style={inlineStyle.modal}
                            >
                                <Modal.Header>Import Root CA Certificate</Modal.Header>
                                <Modal.Content>
                                    <Form onSubmit={(e: any) => this.onUploadCertificate(e)} >
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width120">
                                                Certificate:
                                            </Label>
                                            <Input
                                                className="cert-upload-fileField"
                                                type="file"
                                                accept=".pem,application/x-binary"
                                                onChange={(e: any) => this.setState({filename: e.target.files[0]})}
                                            />
                                            <Button
                                                type="submit"
                                                disabled={this.state.filename ? false : true}
                                                className="system-config-segment-btn"
                                                content="Upload"
                                                title="Upload Certificate"
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width120"/>
                                            <Checkbox
                                                className="config-checkbox left-align-label-smallFont more-paddingTop"
                                                label="File passphrase protected?"
                                                checked={config.options.certPassEna}
                                                onChange={config.onChange.certPassEna}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width120"/>
                                            <Input
                                                type="password"
                                                className="input-width-230"
                                                placeholder="Passphrase"
                                                disabled={!config.options.certPassEna}
                                                value={this.state.tmpCertPass}
                                                onChange={(event, data) => {
                                                    this.setState({tmpCertPass: data.value});
                                                }}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleImportModalClose}>
                                        Cancel
                                    </Button>
                                </Modal.Actions>
                            </Modal>
                        </React.Fragment>
                        )}</OAuth.Context>
                    );
                }}
            </ConfigOptionsAPI>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/security/ldapConfiguration.tsx